/**
 * 路由加载组件
 */
import React from 'react'

import { Button } from 'antd'
import Spin from '../spin'

import style from './index.module.scss'

const Wrapper = ({ children }) => {
  return (
    <div className = { style['route-loading'] }>
      <div className = { style['route-loading-content'] }>
        { children }
      </div>
    </div>
  )
}

export default function RouteLoading ({
  error,
  retry,
  pastDelay
}) {
  return (
    <Wrapper>
      <Spin
        spinning = { true }
        size = 'large'
      />
    </Wrapper>
  )
}
